import api from "../../../api"

export function medicalUser(){
    return api.get(`role_users?role=medical_rep`);
}

export function assignmentSummary(id){
    return api.get(`assignment-summary/${id}`);
}

export function engagementCall(id){
    return api.get(`engagementCallCount/${id}`);
}

export function transferMed(payload){
    return api.post(`transfer-customers-to-medreps`, payload);
}